import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tag-del",
  "use": "icon-tag-del-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tag-del\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0C226.742857 0 0 226.742857 0 512s226.742857 512 512 512 512-226.742857 512-512-234.057143-512-512-512z m256 665.6l-102.4 102.4L512 614.4l-153.6 153.6-102.4-102.4L409.6 512 256 358.4l102.4-102.4L512 409.6l153.6-153.6 102.4 102.4L614.4 512l153.6 153.6z\" fill=\"#888888\" p-id=\"2021\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol